module.exports = __webpack_public_path__ + "img/other_cluster_environment_100px_bluebox.2e03449f.png";